import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import bemClass from './../../utils/bemClass'

import './Footer.css'

const cn = bemClass('Footer')

class Footer extends PureComponent {
    render() {
        const { className } = this.props

        return (
            <div className={`${cn()} ${className}`}>
                <div className={cn('line')} />
                <div className={cn('content')}>
                    <div className={cn('inner')}>
                        <div className={cn('address')}>
                            KARROT Kawa i Kultura<br />
                            ul Częstochowska 20,
                            02-344 Warszawa (Ochota)
                        </div>
                        <div className={cn('copyrights')}>
                            Copyright &copy; 2018 Karrot Kommando
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Footer.propTypes = {
    className: PropTypes.string,
}

Footer.defaultProps = {
    className: '',
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx